import PropTypes from 'prop-types';
import React from 'react';
import {Modal} from 'react-bootstrap';
import './modalStyle.scss';

 function ShowMedModal(props) {
    var {toggleModel, show , title, renderModalBody} = props;
    return (
        <>
            <Modal className="med-modal-about"  show={show} onHide={toggleModel}>
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {renderModalBody}
                </Modal.Body>
            </Modal>
        </>
    );
}

ShowMedModal.propTypes = {
    toggleModel: PropTypes.func,
    show: PropTypes.func,
    title: PropTypes.string,
    renderModalBody: PropTypes.any
};

export default ShowMedModal;